import React from 'react';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BarChart2Icon, TrendingUpIcon, DollarSignIcon, InfoIcon, PlayCircleIcon } from 'lucide-react';
export function MarketIQHome() {
  return <MarketIQLayout activeSection={null} data-id="element-529">
      <div className="max-w-4xl mx-auto py-8 mb-16" data-id="element-530">
        {/* Hero Section */}
        <div className="text-center mb-16" data-id="element-531">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-blue-50 text-[#002f5f] rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-532">
            <BarChart2Icon className="w-4 h-4" data-id="element-533" />
            Market Intelligence
          </div>
          <h1 className="text-5xl md:text-6xl font-['Oswald'] font-bold text-gray-900 uppercase tracking-wide mb-6" data-id="element-534">
            Real-time USDA Market Data
          </h1>
          <p className="text-xl text-gray-600 font-serif leading-relaxed max-w-3xl mx-auto" data-id="element-535">
            Comprehensive pricing, historical trends, and daily analysis for the
            meat and poultry industry.
          </p>
        </div>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-536">
          {/* Beef Card */}
          <Link to="/market-iq/beef" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-537">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-538">
              <TrendingUpIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-539" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-540">
              Beef Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-541">
              Daily boxed beef cutout values, primal cuts, and historical
              spreads.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-542">
              <div data-id="element-543">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-544">
                  Choice Cutout
                </div>
                <div className="font-bold text-gray-900" data-id="element-545">
                  $3.83{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-546">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-547" />
            </div>
          </Link>

          {/* Pork Card */}
          <Link to="/market-iq/pork" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-548">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-549">
              <DollarSignIcon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-550" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-551">
              Pork Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-552">
              Estimated pork carcass cutout and comprehensive primal values.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-553">
              <div data-id="element-554">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-555">
                  Pork Carcass
                </div>
                <div className="font-bold text-gray-900" data-id="element-556">
                  $0.98{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-557">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-558" />
            </div>
          </Link>

          {/* Chicken Card */}
          <Link to="/market-iq/chicken" className="group block bg-white border border-gray-200 rounded-xl p-8 hover:border-[#002f5f] hover:shadow-md transition-all" data-id="element-559">
            <div className="w-12 h-12 bg-gray-50 rounded-lg flex items-center justify-center mb-6 group-hover:bg-blue-50 transition-colors" data-id="element-560">
              <BarChart2Icon className="w-6 h-6 text-gray-700 group-hover:text-[#002f5f]" data-id="element-561" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-562">
              Chicken Dashboard
            </h3>
            <p className="text-gray-600 text-sm mb-6 h-10" data-id="element-563">
              Live chicken reports and whole body trading by size metrics.
            </p>
            <div className="border-t border-gray-100 pt-4 flex items-center justify-between" data-id="element-564">
              <div data-id="element-565">
                <div className="text-xs text-gray-400 uppercase tracking-wider mb-1" data-id="element-566">
                  Nat'l Composite
                </div>
                <div className="font-bold text-gray-900" data-id="element-567">
                  $1.29{' '}
                  <span className="text-xs font-normal text-gray-500" data-id="element-568">/lb</span>
                </div>
              </div>
              <ArrowRightIcon className="w-5 h-5 text-gray-400 group-hover:text-[#002f5f] group-hover:translate-x-1 transition-all" data-id="element-569" />
            </div>
          </Link>
        </div>

        {/* Video Tutorial */}
        <div className="mb-16 bg-gray-50 border border-gray-200 rounded-xl overflow-hidden" data-id="element-570">
          <div className="aspect-video bg-gray-200 flex items-center justify-center relative group cursor-pointer" data-id="element-571">
            <div className="absolute inset-0 bg-gray-900/5 group-hover:bg-gray-900/10 transition-colors" data-id="element-572" />
            <div className="relative flex flex-col items-center gap-3" data-id="element-573">
              <div className="w-16 h-16 rounded-full bg-white/90 shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-574">
                <PlayCircleIcon className="w-10 h-10 text-[#002f5f]" data-id="element-575" />
              </div>
              <span className="text-sm font-semibold text-gray-700" data-id="element-576">
                Watch: How to Use Market IQ
              </span>
            </div>
          </div>
          <div className="px-8 py-4 flex items-center justify-between" data-id="element-577">
            <p className="text-sm text-gray-500" data-id="element-578">
              A quick walkthrough of dashboards, data sources, and key features.
            </p>
            <span className="text-xs text-gray-400 flex-shrink-0 ml-4" data-id="element-579">
              2:45
            </span>
          </div>
        </div>

        {/* Info Section */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 flex flex-col md:flex-row gap-8 items-start" data-id="element-580">
          <div className="flex-shrink-0 bg-white p-3 rounded-full border border-gray-200 shadow-sm" data-id="element-581">
            <InfoIcon className="w-6 h-6 text-[#002f5f]" data-id="element-582" />
          </div>
          <div data-id="element-583">
            <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-584">
              Data Methodology & Sources
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed mb-4" data-id="element-585">
              Market IQ aggregates daily and weekly reports from the USDA
              Agricultural Marketing Service (AMS). Our integration with{' '}
              <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-[#002f5f] font-semibold hover:underline" data-id="element-586">
                MeatMarket.ai
              </a>{' '}
              ensures data is normalized, historically accurate, and updated in
              real-time as reports are published.
            </p>
            <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-[#002f5f] hover:underline inline-flex items-center gap-1" data-id="element-587">
              Visit MeatMarket.ai
              <ArrowRightIcon className="w-3 h-3" data-id="element-588" />
            </a>
          </div>
        </div>
      </div>
    </MarketIQLayout>;
}